import type { TaskListResponse } from '../../services/api/types.gen';

export type TaskCustodyValue = TaskListResponse['custody'];
export type TaskCustodyReason = NonNullable<TaskListResponse['custody_reason']>;

/**
 * Why the External EMR owns a task, in the clinician's words. Before Take Over
 * every imported task is the External EMR's; after it, only work on a claim
 * the External EMR bills.
 */
export const EXTERNAL_BEFORE_MOVE_TOOLTIP =
  'Charted and billed in the External EMR until this chart is taken over.';
/**
 * The same, for an agency without Take Over v2 (`external-emr-take-over`
 * off): it names no action the agency lacks.
 */
export const EXTERNAL_BEFORE_MOVE_BASIC_TOOLTIP =
  'Charted and billed in the External EMR.';
export const EXTERNAL_CLAIM_TOOLTIP =
  'On a claim billed from the External EMR.';

export function externalCustodyTooltip(
  reason: TaskCustodyReason | null | undefined,
  takeOverAvailable: boolean
): string {
  if (reason === 'external_claim') return EXTERNAL_CLAIM_TOOLTIP;
  return takeOverAvailable
    ? EXTERNAL_BEFORE_MOVE_TOOLTIP
    : EXTERNAL_BEFORE_MOVE_BASIC_TOOLTIP;
}

/**
 * Who charts a task, beside who bills it above. Work dated before
 * the day Roger charts from is the External EMR's. Roger warns, never blocks.
 */
/** [E] on any imported visit/task row (Episode Manager, Hotbox, EOE, …). */
export const IMPORTED_FROM_EXTERNAL_EMR_TOOLTIP = 'Imported from External EMR';
export const MANAGED_IN_EXTERNAL_EMR_TASK_BANNER =
  'This task is managed in the external EMR. You should avoid editing it in Roger.';
/** chart-level warn before Take Over moves custody to Roger. */
export const IMPORTED_CHART_BEFORE_TAKE_OVER_BANNER =
  'This chart is still managed in the External EMR until you take it over. You can edit in Roger, but charting in both systems can conflict.';
export const MANAGED_IN_EXTERNAL_EMR_EPISODE_BANNER =
  'This episode is managed in the external EMR. You should avoid editing it in Roger.';

/** The goals note on the episode that contains the day Roger charts from. */
export function visitsBeforeDayNote(day: string): string {
  return `Visits before ${day} are still managed in the external EMR.`;
}
